import { PatchSharedCapTableLinkDto } from '../../../hooks/shared-cap-table/shared-cap-table.types';
import { ShareLinkFormValues } from './share-cap-table-modal';

/**
 * Two fields carry three states each, and the omitted key is the "keep" instruction — so a plain
 * falsy check silently inverts the owner's intent rather than failing:
 *
 * - `expireInterval` — `undefined` keeps the stored `expiresAt`, `null` removes it.
 * - `password` — `''` stands for the hash already stored, `null` removes protection.
 */
export const buildSharedCapTableLinkPatch = ({
  expireInterval,
  note,
  password,
  settings,
}: ShareLinkFormValues): PatchSharedCapTableLinkDto => ({
  ...(expireInterval === undefined ? {} : { expireInterval }),
  note: note || null,
  ...(password === '' ? {} : { password }),
  settings,
});
